import {Grid, InputLabel, MenuItem, Select} from "@mui/material";
import React from "react";
import {IApplicationAssignableRole} from "../../../Interfaces/Common/IApplicationAssignableRole";
import {IEmployee} from "../../../Interfaces/Admin/IEmployee";
import {IDealerServiceDecisionReasonCode} from "../../../Interfaces/Common/IDealerServiceDecisionCodeReason";

interface AssignableEmployeeSelectProps {
  roleLabel: string;
  selectedEmployeeId: string;
  selectableEmployees?: IEmployee[];
  applicationAssignableRole: IApplicationAssignableRole;
  sequence: number;
  onChange: (roleId: string, sequence: number, value: string) => void;
  assignable: boolean;
}

export default function AssignableEmployeeSelect(props: AssignableEmployeeSelectProps) {
  return (
    <Grid item xs={12} sm={6}>
      <InputLabel id="select-employee-label">{props.roleLabel ?? ''}:</InputLabel>
      <Select 
        name="employeeSelector" 
        fullWidth
        labelId="select-salesperson-label"
        variant='standard'
        value={props.selectedEmployeeId || ""}
        onChange={(e: any) => props.onChange(props.applicationAssignableRole.employeeRoleId, props.sequence, e.target.value)}
        inputProps={{ readOnly: !props.assignable }}
      >
        <MenuItem key="null" value={undefined}>(unassigned)</MenuItem>
        {props.selectableEmployees?.map((se, key) => (
          <MenuItem key={key} value={se.id}>{se.firstName} {se.lastName}</MenuItem>
        ))}
      </Select>
    </Grid>
  )}